import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToHourPipe } from "./pipes/to-hour.pipe";
import { ToSecondsPipe } from "./pipes/to-seconds.pipe";
import { AlertComponent } from "./dialogs/alert/alert.component";
import { MatDialogModule } from "@angular/material/dialog";
import { DialogService } from "../services/dialog.service";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatExpansionModule } from "@angular/material/expansion";
import { FloorPipe } from "./pipes/floor.pipe";
import { PhonePatternPipe } from './pipes/phone-pattern.pipe';
import { MatNativeDateModule } from "@angular/material/core";


@NgModule({
  declarations: [
    ToHourPipe,
    ToSecondsPipe,
    AlertComponent,
    FloorPipe,
    PhonePatternPipe,
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatNativeDateModule,
  ],
  providers: [
    ToHourPipe,
    ToSecondsPipe,
    FloorPipe,
    DialogService,
  ],
    exports: [
        ToHourPipe,
        ToSecondsPipe,
        MatDialogModule,
        MatFormFieldModule,
        FloorPipe,
        PhonePatternPipe,
    ]
})

export class SharedModule { }
